import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react'
import userInfo from 'meinian-package/src/common/userInfo'
import { RejectCommentShow } from '../rejectCommentShow'
import { RejectCommentWindow } from '../rejectCommentWindow'

export default forwardRef(({
  commentShowOpenType,
  className,
  chidClassName,
  style,
  rejectWindowClassName,
  messageData,
}, ref) => {
  const [leaveDisplayVisible, setLeaveDisplayVisible] = useState(false) // 驳回评论展示窗口
  const [leaveCommentVisible, setLeaveCommentVisible] = useState(false)
  const [leaveCommentInitiativeBehavior, setLeaveCommentInitiativeBehavior] = useState(true) // 是否是主动打开留言评论窗口

  useImperativeHandle(ref, () => {
    return {
      onDisplayVisible: (val) => setLeaveDisplayVisible(val),
      onCommentVisible: (callback) => {
        if (typeof callback === 'function') {
          setLeaveCommentVisible(pre => callback?.(pre))
        } else {
          setLeaveCommentVisible(callback)
        }
      },
      onInitiativeBehavior: (val) => setLeaveCommentInitiativeBehavior(val)
    }
  })

  const onLeaveComment = (val) => {
    setLeaveCommentInitiativeBehavior(true)
    setLeaveCommentVisible(val)
  }

  useEffect(() => {
    if (messageData.blogComment?.length && messageData?.userId === userInfo.userId) { // 当已经存在驳回评论 并且属于自己的款式的时候展示
      setLeaveDisplayVisible(true)
    } else {
      setLeaveDisplayVisible(false)
    }
  }, [messageData.blogComment])

  const onPublish = () => { // 评论完成后 判断 是否是属于自己的款式
    if (messageData.userId === userInfo.userId) {
      setLeaveDisplayVisible(true)
    }
  }

  return <div className={className}>
    {
      leaveDisplayVisible && !!messageData.blogComment?.length && <RejectCommentShow
        commentShowOpenType={commentShowOpenType}
        style={style}
        messageData={messageData}
        chidClassName={chidClassName}
        onClose={() => setLeaveDisplayVisible(false)}
      />
    }
    {
      leaveCommentVisible && <RejectCommentWindow
        className={rejectWindowClassName}
        leaveCommentInitiativeBehavior={leaveCommentInitiativeBehavior}
        style={style}
        chidClassName={chidClassName}
        onClose={() => onLeaveComment(false)}
        onPublish={onPublish}
        data={messageData}
      />
    }
  </div>
})
